module.exports = __webpack_public_path__ + "img/model_v3_bg_1.8af38c97.png";